module.exports = __webpack_public_path__ + "img/Wasserfahrzeug.bdcd5429.svg";